export const APP_CONFIG = {
  // loadingDuration: 4500
  // loadingDuration: 200000
};
